import {
  Upload,
  UploadAsyncProps,
  UploadProps,
} from '@progress/kendo-react-upload';
import _ from 'lodash';
import { ValidationError } from '../../apps/benefit/models/Errors';
import { productsService } from '../../apps/benefit/services/products';
import ErrorViewer from './ErrorViewer';
import { getAuthHeaders } from '../ajax/index';

interface IFileInputProps {
  controlClassName?: string;
  helper?: string;
  label?: string | any;
  aditionalInformation?: string;
  isProductDocumentation?: boolean;
  language?: string;
  errors?: ValidationError[];
}

const FileInput = (props: IFileInputProps & UploadProps & UploadAsyncProps) => {
  const {
    label,
    id,
    controlClassName,
    helper,
    errors,
    aditionalInformation,
    isProductDocumentation,
  } = props;

  const classNames = `control-group ${controlClassName ?? ''} ${
    errors ? 'control-error' : ''
  }`.trim();

  const buildProductDocumentationElement = (message: string) => {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(message, 'text/html');
    const aText = htmlDoc.getElementsByTagName('a')[0].text;
    const pText = htmlDoc.getElementsByTagName('p')[0].innerText;
    const pTextArr = _.split(pText, aText);
    return (
      <p>
        {pTextArr.length > 0 ? pTextArr[0] : ''}
        <a
          href=""
          onClick={async (e: any) => {
            e.preventDefault();
            await productsService.downloadProductDocumentation('course_app');
          }}
        >
          {aText}
        </a>
        {pTextArr.length > 1 ? pTextArr[1] : ''}
      </p>
    );
  };

  return (
    <div className={classNames}>
      <div className="control-content">
        {!!label && (
          <label
            htmlFor={id}
            dangerouslySetInnerHTML={{ __html: label ?? <p></p> }}
          ></label>
        )}
        {aditionalInformation && (
          <div className="text-container">
            {isProductDocumentation ? (
              <label htmlFor={id}>
                {buildProductDocumentationElement(aditionalInformation)}
              </label>
            ) : (
              <label
                htmlFor={id}
                dangerouslySetInnerHTML={{
                  __html: aditionalInformation ?? <p></p>,
                }}
              />
            )}
          </div>
        )}
        <Upload
          {...props}
          withCredentials={true}
          saveHeaders={getAuthHeaders()}
        />
      </div>
      {!!helper && <div className="control-info">{helper}</div>}
      <ErrorViewer errors={errors} />
    </div>
  );
};

export default FileInput;
